import { useCallback, useEffect, useState } from 'react'

export const useColumns = (defaultColumns) => {
  const [columns, setColumns] = useState(null)

  const onColumnManagerChange = useCallback(
    (updatedColumns) => {
      const selectedColumns = defaultColumns.filter((column) =>
        updatedColumns.some((managedColumn) => managedColumn.value === column.key),
      )
      setColumns(selectedColumns)
    },
    [defaultColumns],
  )

  useEffect(() => {
    setColumns(defaultColumns)
  }, [])

  return [columns, onColumnManagerChange]
}

export default useColumns
